import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { enumCompanyBusinessType } from '@app/data-layer/enums/companies';
import { enumDocumentType } from '@app/data-layer/enums/documents';
import { FormHelper } from '@helpers/form.helper';

@Injectable({ providedIn: 'root' })
export class CbpAssignedNumberRequestService {
  private _formGroup: UntypedFormGroup;
  private _isAnyBusinessTypeRelatedDocsMissing: boolean = true;

  constructor(private fh: FormHelper) {}

  public initializeFormGroup() {
    this._formGroup = this.fh.createCbpAssignedNumberRequestFormGroup();
  }

  public getFormGroup(): UntypedFormGroup {
    return this._formGroup;
  }

  public setIsAnyBusinessTypeRelatedDocsMissing(value: boolean) {
    this._isAnyBusinessTypeRelatedDocsMissing = value;
  }

  public getIsAnyBusinessTypeRelatedDocsMissing(): boolean {
    return this._isAnyBusinessTypeRelatedDocsMissing;
  }

  public getBusinessTypeDocuments(): { [key: number]: enumDocumentType[] } {
    return {
      [enumCompanyBusinessType.CORPORATION]: [
        enumDocumentType.CBP_ASSIGNED_NUMBER_POWER_OF_ATTORNEY,
        enumDocumentType.COMPANY_ARTICLES_OF_INCORPORATION,
        enumDocumentType.OFFICERS_AUTHORIZATION_CONFIRMATION,
        enumDocumentType.ID_DOCUMENT_1,
        enumDocumentType.ID_DOCUMENT_2,
      ],
      [enumCompanyBusinessType.SOLE_PROPRIETOR]: [
        enumDocumentType.CBP_ASSIGNED_NUMBER_POWER_OF_ATTORNEY,
        enumDocumentType.COMPANY_ESTABLISHMENT_CERTIFICATE,
        enumDocumentType.ID_DOCUMENT,
      ],
      [enumCompanyBusinessType.INDIVIDUAL]: [enumDocumentType.CBP_ASSIGNED_NUMBER_POWER_OF_ATTORNEY, enumDocumentType.ID_DOCUMENT],
    };
  }

  public getRequiredDocumentsListTexts(): { [key: number]: string[] } {
    return {
      [enumCompanyBusinessType.CORPORATION]: [
        'LABELS.IOR_ARTICLES_OF_INCORPORATION',
        'LABELS.SIGNED_POA_BY_TWO_IOR_OFFICERS',
        'LABELS.POA_SIGNING_AUTHORIZING_DOCUMENT',
        'LABELS.INTERNATIONAL_PASSPORTS_OF_TWO_SIGNATORIES',
      ],
      [enumCompanyBusinessType.SOLE_PROPRIETOR]: [
        'LABELS.ESTABLISHMENT_OF_CERTIFICATE',
        'LABELS.SIGNED_POA_BY_IOR_OWNER',
        'LABELS.IOR_OWNER_INTERNATIONAL_PASSPORT',
      ],
      [enumCompanyBusinessType.INDIVIDUAL]: ['LABELS.SIGNED_POA', 'LABELS.COPY_OF_YOUR_INTERNATIONAL_PASSPORT'],
    };
  }
}
